//******************************************************************************
//子孫タイル、先祖タイルを探す関数

//******************************************************************************
/**
 * 子孫タイルを探す関数
 * @param {{x:number, y:number, z:number}} xyz 探索対象タイル座標
 * @param {mixed} [depth] 探索する階層（デフォルト1）
 * @returns {Array<{x:number, y:number, z:number}>} 子孫タイルのタイル座標配列
*/
export const findChildren = (xyz, depth = 1) => {
	//--------------------------------------------------------------------------
	// 結果を格納する配列を用意
	const descendants = [];
	//--------------------------------------------------------------------------
	// 階層を下って処理
	for (let i = 1; i <= depth; i += 1) {
		// ここの親要素郡は最後に登録した配列（配列の各要素が親タイル座標）
		const parents = descendants.length === 0 ? [xyz] : descendants[descendants.length - 1];
		// 子タイル配列を用意
		const children = [];
		// 親タイルを操作
		parents.forEach((parent) => {
			// 各親タイルの子タイルを決めて配列に格納
			[[0, 0], [1, 0], [0, 1], [1, 1]].forEach((value) => {
				const x = parent.x * 2 + value[0];
				const y = parent.y * 2 + value[1];
				const z = parent.z + 1;
				children.push({ x, y, z });
			});
		});
		// 子タイル配列を結果配列に格納
		descendants.push(children);
	}
	//--------------------------------------------------------------------------
	// 結果を一時配列で返す
	return descendants.flat();
};

//******************************************************************************
/**
 * 先祖タイルを探す関数
 * @param {{x:number, y:number, z:number}} xyz 探索対象タイル座標
 * @param {mixed} [depth] 探索する階層（デフォルト1）
 * @returns	{{x:number, y:number, z:number}} 先祖タイルのタイル座標
*/
export const findParents = (xyz, depth = 1) => {
	//--------------------------------------------------------------------------
	// 結果を格納する配列を用意
	const ancestors = [];
	//--------------------------------------------------------------------------
	// 階層を上って処理
	for (let i = 1; i <= depth; i += 1) {
		// ズームレベルで分岐
		if (xyz.z - i < 0) {
			// 0未満になったら処理を停止
			break;
		} else {
			// 親タイルを結果配列に格納
			ancestors.push({
				x: Math.floor(xyz.x / 2 ** i),
				y: Math.floor(xyz.y / 2 ** i),
				z: xyz.z - i
			});
		}
	}
	//--------------------------------------------------------------------------
	// 結果を返す
	return ancestors;
};
